<template>
  <div class="navigation-top">
    <nav class="navigation-top__bar">
      <RouterLink v-for="link in topBarLinks" :key="link.label" :to="link.route" class="navigation-top__link">
        <SvgIcon v-if="link.icon" :id="link.icon" class="navigation-top__icon" />
        {{ link.label }}
      </RouterLink>
    </nav>

    <div class="navigation-top__container">
      <router-link to="/">
        <img v-scroll:reveal src="/images/logo.png" alt="Logo ICÉA" class="navigation-top__logo" />
      </router-link>

      <ul class="navigation-top__list">
        <li
          v-for="(section, key, linkIndex) in navSections"
          :key="key"
          v-scroll:reveal="{ delay: 50 + linkIndex * 50 }"
          class="navigation-top__item"
        >
          <button @click.stop="setCurrentNavSectionKey(key)" @keydown.space.stop="setCurrentNavSectionKey(key)">
            {{ section.label }}
          </button>

          <span
            class="navigation-top__arrow"
            @click.stop="setCurrentNavSectionKey(key)"
            @keydown.space.stop="setCurrentNavSectionKey(key)"
          >
            <SvgIcon id="arrow" />
          </span>
        </li>

        <li v-if="$device.laptop">
          <RouterLink
            v-scroll:reveal="{ delay: 75 + Object.keys(navSections).length * 50 }"
            :to="{ name: 'contact' }"
            class="button -smaller navigation-top__button"
          >
            Nous contacter
          </RouterLink>
        </li>
      </ul>

      <button class="navigation-top__burger" @click="$emit('toggle-sidenav')">
        <SvgIcon id="menu" />
      </button>
    </div>

    <transition name="navigation-box" mode="out-in">
      <div v-if="currentNavSection" :key="currentNavSectionKey" class="navigation-box" @click.stop @keydown.space.stop>
        <RouterLink
          :to="currentNavSection.main.route"
          class="navigation-box__side"
          @click.native.stop="closeNavSection"
          @keydown.native.space.stop="closeNavSection"
        >
          <div>
            <h2 v-scroll:reveal class="navigation-box__title">{{ currentNavSection.main.title }}</h2>
            <p v-scroll:reveal="{ delay: 50 }" class="navigation-box__text">{{ currentNavSection.main.content }}</p>
          </div>

          <div v-scroll:reveal="{ delay: 100 }" class="navigation-box__button">
            Explorez
            <SvgIcon id="action-arrow" />
          </div>
        </RouterLink>

        <nav class="navigation-box__content">
          <ul
            v-for="(section, sectionIndex) in currentNavSection.sections"
            :key="section.title"
            class="navigation-box__section"
          >
            <li v-scroll:reveal="{ delay: 120 + sectionIndex * 75 }" class="navigation-box__subtitle">
              {{ section.title }}
            </li>

            <li
              v-for="(link, linkIndex) in section.links"
              :key="link.label"
              v-scroll:reveal="{ delay: 120 + sectionIndex * 75 + linkIndex * 50 }"
              class="navigation-box__item"
              @click.stop="closeNavSection"
              @keydown.space.stop="closeNavSection"
            >
              <RouterLink v-if="link.route" :to="link.route" class="navigation-box__link">
                {{ link.label }}
              </RouterLink>

              <a
                v-else-if="link.url"
                :href="link.url"
                class="navigation-box__link"
                target="_blank"
                rel="noopener noreferrer"
              >
                {{ link.label }}
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'NavigationTop',
  props: {
    navSections: { type: Object, required: true }
  },
  data() {
    return {
      topBarLinks: [
        { label: 'Devenir membre', route: { name: 'about-members-register' } },
        { label: 'Faire un don', route: { name: 'donation' } },
        { label: 'Rechercher', icon: 'search', route: { name: 'search' } }
      ],
      currentNavSectionKey: null,
      isVisible: true,
      refNode: null
    }
  },
  computed: {
    currentNavSection() {
      if (!this.currentNavSectionKey || !this.navSections[this.currentNavSectionKey]) return null
      return this.navSections[this.currentNavSectionKey]
    }
  },
  watch: {
    '$device.laptop': {
      immediate: true,
      handler(isLaptop) {
        if (!isLaptop) this.isVisible = true
        else this.updateVisibility()
      }
    },
    currentNavSectionKey(newKey, oldKey) {
      if (newKey && !oldKey) {
        // setTimeout(() => {
        document.body.addEventListener('click', this.closeNavSection)
        // }, 100)
      } else if (!newKey && oldKey) {
        document.body.removeEventListener('click', this.closeNavSection)
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$scroll.on(this.updateVisibility)
    })
  },
  methods: {
    setCurrentNavSectionKey(key) {
      if (this.currentNavSectionKey === key) {
        this.closeNavSection()
      } else {
        this.currentNavSectionKey = key
      }
    },
    closeNavSection() {
      this.currentNavSectionKey = null
    },
    getRefNode() {
      this.refNode = document.querySelector('[data-peekaboo]')
      return this.refNode
    },
    updateVisibility() {
      if (!this.$device.laptop) return

      const refNode = this.refNode || this.getRefNode()
      if (!refNode) return

      this.isVisible = refNode.getBoundingClientRect().top < 72
    }
  }
}
</script>
